"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var DynamicFontSizeContainer = function (_a) {
    var text = _a.text, possibleFontSizes = _a.possibleFontSizes;
    var containerRef = (0, react_1.useRef)(null);
    var textRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(possibleFontSizes[0]), fontSize = _b[0], setFontSize = _b[1]; // Initial font size
    var _c = (0, react_1.useState)(false), allowWrap = _c[0], setAllowWrap = _c[1];
    var _d = (0, react_1.useState)(false), isAtMinFontSize = _d[0], setIsAtMinFontSize = _d[1];
    var resizeText = function () {
        if (containerRef.current && textRef.current) {
            var containerWidth = containerRef.current.offsetWidth;
            var low = 0;
            var high = possibleFontSizes.length - 1;
            var newFontSize = possibleFontSizes[0];
            while (low <= high) {
                var mid = Math.floor((low + high) / 2);
                textRef.current.style.fontSize = "".concat(possibleFontSizes[mid], "px");
                var textWidth = textRef.current.offsetWidth;
                if (textWidth > containerWidth) {
                    high = mid - 1;
                }
                else {
                    newFontSize = possibleFontSizes[mid];
                    low = mid + 1;
                }
            }
            if (newFontSize === possibleFontSizes[0]) {
                setAllowWrap(true);
                setIsAtMinFontSize(true);
            }
            else {
                setAllowWrap(false);
                setIsAtMinFontSize(false);
            }
            setFontSize(newFontSize);
        }
    };
    (0, react_1.useEffect)(function () {
        // Reset state when the text changes
        setIsAtMinFontSize(false);
        setAllowWrap(false);
        resizeText();
    }, [text, possibleFontSizes]);
    (0, react_1.useEffect)(function () {
        if (!isAtMinFontSize) {
            resizeText();
        }
        window.addEventListener('resize', resizeText);
        return function () {
            window.removeEventListener('resize', resizeText);
        };
    }, [isAtMinFontSize]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: containerRef, style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'visible',
        }, children: (0, jsx_runtime_1.jsx)("div", { ref: textRef, style: {
                fontSize: "".concat(fontSize, "px"),
                whiteSpace: allowWrap ? 'normal' : 'nowrap',
                textAlign: 'center',
            }, children: text }) }));
};
exports.default = DynamicFontSizeContainer;
//# sourceMappingURL=DynamicFontSizeContainer.js.map